module.exports = __webpack_public_path__ + "img/banner02.58e7cdca.png";